export function acfNavEvents() {
	const openMenu = document.querySelector("#flux-open-menu");
	if (!openMenu) return;
	async function firstClick(e) {
		openMenu.removeEventListener("click", firstClick);
		try {
			const { initNav } = await import("../../../acf-main-menu/orion/js/acf-menu.js");
			const openNav = initNav();
			openNav(e);
		} catch (err) {
			console.error("Failed to load module:", err);
		}
	}
	openMenu.addEventListener("click", firstClick);
	document
		.querySelectorAll('nav a[href="#"]')
		.forEach((el) => el.addEventListener("click", (e) => e.preventDefault()));
}
